import { storeToRefs } from 'pinia';
import { uiNotificationStore } from '~/stores/uiNotification';

export default function () {

  const store = uiNotificationStore();
  const { uiNotifications } = storeToRefs(store);

  return {
    ...store,
    uiNotifications,
  };

}